import { useSelector } from 'react-redux';
import { OAuthButton } from '../oauth/OAuthButton';
import { OAuthProviders } from '../oauth/OAuthProviders';
import { useLoadMicrosoft } from './useLoadMicrosoft';
import { useMicrosoft } from './useMicrosoft';
import { isOAuthLoading } from '../oauth/utils/isOAuthLoading';
import { jsx as _jsx } from "react/jsx-runtime";
export const MicrosoftButton = () => {
  const {
    onClick
  } = useMicrosoft();
  const isAuthLoading = useSelector(state => isOAuthLoading(state, OAuthProviders.Microsoft));
  const {
    isLoading: isScriptLoading
  } = useLoadMicrosoft();
  return /*#__PURE__*/_jsx(OAuthButton, {
    isLoading: isScriptLoading || isAuthLoading,
    oauth: OAuthProviders.Microsoft,
    onClick: onClick
  });
};